import axios from "axios";
import local from "../classes/local";
import getEnvironment from "./get.environment";

export const loadGlobalHeader = async (enableLiveChat = false) => {
    const headerId = 'root';
    const header = document.getElementById(headerId);
    const language = local.getItem('language') === 'Spanish' ? 'es' : 'en';

    // get current query parameters
    let param = window.location.search;
    const params = param && param.substr(1, param.length);

    // strip out any existing language query parameter
    let finalQueryParams = params && params.split('&').filter(param => {
        const key = param.split('=')[0];
        return key !== 'lang' && key !== 'Lang'
    })
        .join("&")

    // set as query params only, so it works on any page
    let langLink = language === 'es' ? '?Lang=en-us' : '?Lang=es-mx';

    if(finalQueryParams)
        langLink += "&" + finalQueryParams;

    // set properties on div that header will use
    header?.setAttribute('lang', language);
    header?.setAttribute('lang-toggle-link', langLink);
    if (enableLiveChat) {
        header?.setAttribute('enable-live-chat', 'true');
    }

    const env = getEnvironment();
    const getHeaderUrl = (env?: string, hash: string | null = null) => {
        let url = `https://frontend.${env}.medicare.gov/`;
        if (!env) {
            url = 'https://frontend.medicare.gov/';
        }
        if (hash) {
            url += (hash + '/');
        }
        return url;
    };

    const dev = getHeaderUrl('dev', 'f7fef6a');
    const test = getHeaderUrl('test');
    const imp = getHeaderUrl('imp');
    const prod = getHeaderUrl();

    const lookup = {
        localhost: imp,
        development: dev,
        test: test,
        implementation: imp,
        production: prod,
    };

    // @ts-ignore
    const baseUrl = lookup[env] || imp;

    const res = await axios.get(baseUrl + 'asset-manifest.json');
    const files: any[] = res.data.entrypoints;
    files.forEach(f => {
        const url = baseUrl + f;
        if (f.endsWith('.js')) {
            importJsFile(url);
        } else if (f.endsWith('.css')) {
            importCssFile(url);
        }
    });

};

const importJsFile = (url: string) => {
    const scriptEl = document.createElement('script');
    scriptEl.src = url;
    scriptEl.type = 'text/javascript';

    const head = document.head;
    head.insertBefore(scriptEl, head.childNodes[0]);
};

const importCssFile = (url: string) => {
    const linkEl = document.createElement('link');
    linkEl.href = url;
    linkEl.rel = 'stylesheet';
    linkEl.type = 'text/css';

    const head = document.head;
    head.insertBefore(linkEl, head.childNodes[0]);
};